export default __webpack_public_path__ + "static/media/web.aad12774.mp4";